import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { JobEvaluationFormsHttpService } from './job-evaluation-forms-http.service';
import { JobEvaluationFormsActions } from './job-evaluation-forms.store';

@Injectable({
  providedIn: 'root',
})
export class JobEvaluationFormsEffects {
  private readonly actions$ = inject(Actions);
  private readonly httpService = inject(JobEvaluationFormsHttpService);

  public effects = createEffectFactory(JobEvaluationFormsActions, this.actions$);

  public fetchOne$ = this.effects(JobEvaluationFormsActions.fetchOne, ({ payload }) =>
    this.httpService.fetchOne$(payload.jobId).pipe(
      map(response => ({
        data: {
          jobId: payload.jobId,
          jobInterviewTemplates: response.offerInterviewTemplates,
        },
      })),
    ),
  );
}
